import { Component, OnInit, Injector } from '@angular/core';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-request-for-new-pool-modal',
  templateUrl: './request-for-new-pool-modal.component.html',
  styleUrls: ['./request-for-new-pool-modal.component.css']
})
export class RequestForNewPoolModalComponent extends ModalBaseComponent implements OnInit {

  constructor(private inject: Injector) {
    super(inject);
   }

  ngOnInit() {
  }

  public closeModal(){

  }

}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/request-for-new-pool/request-for-new-pool-modal.component.ts